//https://www.youtube.com/watch?v=13eja_RYimU&list=PL4cUxeGkcC9jERUGvbudErNCeSZHWUVlb&index=3
import { initializeApp } from "firebase/app";
import {getFirestore, collection, getDocs, addDoc,deleteDoc, doc} from 'firebase/firestore';
import { getStorage } from "firebase/storage";



    const firebaseConfig = {
        apiKey: "AIzaSyCcpwqblC2mfhTJHdqnpbm6njEJBvo84QE",
        authDomain: "language-app-4159f.firebaseapp.com",
        projectId: "language-app-4159f",
        storageBucket: "language-app-4159f.appspot.com",
        messagingSenderId: "606253652194",
        appId: "1:606253652194:web:0dcc45b7be121a887ee6bb"
    };

   

    //init firebase app
    const app = initializeApp(firebaseConfig);

    export const storage = getStorage(app);

    //init firebase connection
    export const db = getFirestore();

    //get collection ref to the database
    //you pass in the db you want and the collection
    export const collectionRef = collection(db,'todos');



    //REDECLARED in APP.js
    // //get collection data
    // export const documents = getDocs(collectionRef)
    // .then((snapshot)=>{
    //     var dataGrab = [];
    //     snapshot.docs.forEach((doc)=>{
    //         dataGrab.push({...doc.data(),id:doc.id})
    //     })
    //     //we'll do it from App.js
    //     //console.log(dataGrab);
    // })

